import { render, staticRenderFns } from "./SubscribeSettings.vue?vue&type=template&id=b3b8c274&scoped=true"
import script from "./SubscribeSettings.vue?vue&type=script&lang=js"
export * from "./SubscribeSettings.vue?vue&type=script&lang=js"
import style0 from "./SubscribeSettings.vue?vue&type=style&index=0&id=b3b8c274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b8c274",
  null
  
)

export default component.exports